<template>
  <v-container class="search booking-slot-search">
    <v-row justify="center" class="booking-slot-search__row">
      <v-col
        cols="12"
        v-if="selectedElement.startDate && selectedElement.endDate"
        class="booking-slot-search__notice-col"
      >
        <div class="booking-slot-search__notice">
          This venue is available from {{ selectedElement?.startDate }} to
          {{ selectedElement?.endDate }}
        </div>
      </v-col>

      <v-col cols="12" class="booking-slot-search__schedule-col">
        <div class="booking-slot-search__schedule-card">
          <date-search-component-vue
            ref="dateSearchComponent"
            @search="setSearchDate"
            @dateSelected="onDateSelected"
            :checkValidation="checkValidation"
            :selectedElement="selectedElement"
            :initialBookingAllowed="initialBookingAllowed"
            :additionalBookingAllowed="additionalBookingAllowed"
            :otpUserBookingHours="otpUserBookingHours"
            :selectedDate="selectedDate"
            :minDaysInAdvance="minDaysInAdvanceForPicker"
            :daysInAdvanceEnabled="daysInAdvanceEnable"
            :minHoursInAdvance="minHoursInAdvanceForPicker"
            :hoursInAdvanceEnabled="hoursInAdvanceEnable"
            :bookedEvents="bookedEvents"
          >
            <template #sidebar-extra>
              <div class="booking-slot-search__people">
                <label class="booking-slot-search__label">Number of people</label>
                <v-text-field
                  class="booking-slot-search__input"
                  v-model="maxPeople"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  min="1"
                  hide-details
                ></v-text-field>
              </div>
            </template>
          </date-search-component-vue>
        </div>
      </v-col>

      <v-col cols="12" v-if="timeRangeInvalid && !fulldayChecked">
        <div class="booking-slot-search__error">
          End time must be later than start time.
        </div>
      </v-col>
      <v-col cols="12" v-if="showTimeError == true && !fulldayChecked">
        <div class="booking-slot-search__error">
          {{ bookingTimeErrorMessage || 'Minimum initial booking is 1 hour. Additional half-hour bookings are allowed.' }}
        </div>
      </v-col>
      <v-col cols="12" v-if="currentTimeCheck">
        <div class="booking-slot-search__error">
          Booking for this date and time is no longer available.
        </div>
      </v-col>
      <v-col cols="12" v-if="bookingInvalid && timeErrorType === 'start_before_opening'">
        <div class="booking-slot-search__error">
          {{ errorMessageTime }}
        </div>
      </v-col>
      <v-col cols="12" v-if="bookingInvalid && timeErrorType === 'end_after_closing'">
        <div class="booking-slot-search__error">
          End time cannot be later than {{ errorMessageTime }}.
        </div>
      </v-col>
      <v-col cols="12" v-if="bookingInvalid && !timeErrorType && errorMessageTime">
        <div class="booking-slot-search__error">
          {{ errorMessageTime }}
        </div>
      </v-col>
      <v-col cols="12" v-if="DuplicateValidationError">
        <div class="booking-slot-search__error">
          This time slot is already in your booking. Please choose a different date or time.
        </div>
      </v-col>
      <v-col cols="12" v-if="ConflictError">
        <div class="booking-slot-search__error">
          This time slot conflicts with another session. Please review and adjust your selection.
        </div>
      </v-col>
      <v-col cols="12" v-if="bookingInvalid && timeErrorType === 'no_slots_available'">
        <div class="booking-slot-search__error">
          {{ errorMessageTime }}
        </div>
      </v-col>
      <v-col cols="12" v-if="slotSearchError">
        <div class="booking-slot-search__error">
          {{ slotSearchError }}
        </div>
      </v-col>
    </v-row>

    <div class="booking-slot-search__actions">
      <button
        type="button"
        class="booking-page-btn booking-page-btn--primary"
        :style="{ backgroundColor: buttonColor, color: 'var(--booking-button-font-color)' }"
        :disabled="
          loading[3] || (!timeValidity && !fulldayChecked) || !!showTimeError || bookingInvalid
        "
        @click="search()"
      >
        <span v-if="loading[3]">Adding slot…</span>
        <span v-else>Add Slot</span>
      </button>
    </div>
  </v-container>
</template>

<script>
import DateSearchComponentVue from "./../common/DateSearchComponent/index.vue";
import { search } from "../../../server/api";
import moment from "moment";
import {
  getTemporarybookingDetails,
  getBookingGeneral,
  getBookingVenueTypeSettings,
} from "../../store/vuexStore";
import { applyBookingTheme } from "@/utils/bookingTheme.js";

export default {
  components: {
    DateSearchComponentVue,
  },

  props: ["selectedvenuename", "fulldayChecked", "otpUserBookingHours", "venuesFromAPI", "selectedDate", "bookedEvents"],
  data() {
    return {
      dateSearch: {},
      buttonColor: "",
      DuplicateValidationError: false,
      ConflictError: false,
      bookingVenuesId: [],
      searchResult: false,
      startTime: new Date(),
      endTime: new Date(),
      date: new Date(),
      validateHours: [],
      loading: [],
      bookingList: [],
      showResults: false,
      timeValidity: false,
      currentTimeCheck: false,
      maxPeople: "",
      minPeople: "",
      venuesId: [],
      venueType: [],
      selectedVenueType: "",
      selectedBookingList: [],
      showTimeError: false,
      timeRangeInvalid: false,
      bookingInvalid: false,
      errorMessageTime: "",
      timeErrorType: null,
      slotSearchError: "",
      bookingTimeErrorMessage: "",
      initialBookingAllowed: 1,
      additionalBookingAllowed: 0.5,
      selectedvenueType: sessionStorage.getItem("selectedvenuetype"),
      selectedvenueName: sessionStorage.getItem("selectedvenuename"),
      checkValidation: false,
      selectedElement: "",
      events: [
        {
          id: 1,
          start_date: "2022-12-20 6:00",
          end_date: "2020-01-20 15:00",
          text: "Event 1",
        },
        {
          id: 2,
          start_date: "2022-12-23 6:00",
          end_date: "2022-12-23 20:00",
          text: "Event 2",
        },
      ],
      checkVenue: true,
      venueTypeSettings: [],

      daysInAdvanceEnable: false,
      minDays: 0,
      hoursInAdvanceEnable: false,
      minHours: 0,
      limitMaxDays: 0,
    };
  },
  computed: {
    minDaysInAdvanceForPicker() {
      return this.daysInAdvanceEnable && this.minDays > 0 ? this.minDays : 0;
    },
    minHoursInAdvanceForPicker() {
      return this.hoursInAdvanceEnable && this.minHours > 0 ? this.minHours : 0;
    },
  },
  watch: {
    maxPeople() {
      this.venueType = [];
      this.searchResult = false;
    },
    initialBookingAllowed() {
      // Trigger validation when values change
      this.$nextTick(() => {
        if (this.$refs.dateSearchComponent && this.$refs.dateSearchComponent.validateBookingTime) {
          this.$refs.dateSearchComponent.validateBookingTime();
        }
      });
    },
    additionalBookingAllowed() {
      // Trigger validation when values change
      this.$nextTick(() => {
        if (this.$refs.dateSearchComponent && this.$refs.dateSearchComponent.validateBookingTime) {
          this.$refs.dateSearchComponent.validateBookingTime();
        }
      });
    },
  },
  async created() {
    const bookingGeneral = getBookingGeneral() || {};
    applyBookingTheme(bookingGeneral);
    this.buttonColor = bookingGeneral.buttoncolor;
    this.checkValidation = this.fulldayChecked;
    

    let venueTypeSettings = await getBookingVenueTypeSettings();

    let selectedElement = venueTypeSettings.find(
      (el) => el.venueType === this.selectedvenueType
    );
    this.selectedElement = selectedElement || {};
    
    // Get booking time restrictions from selectedElement (venue data)
    if (selectedElement) {
      this.initialBookingAllowed = selectedElement.initialBookingAllowed || 1;
      this.additionalBookingAllowed = selectedElement.additionalBookingAllowed || 0.5;
      this.applyAdvanceBookingSettings(selectedElement);

      // Trigger validation in DateSearchComponent after values are set
      this.$nextTick(() => {
        if (this.$refs.dateSearchComponent && this.$refs.dateSearchComponent.validateBookingTime) {
          this.$refs.dateSearchComponent.validateBookingTime();
        }
      });
    }
  },
  methods: {
    setSlotSearchError(message) {
      this.slotSearchError = message || "";
    },

    clearSlotSearchErrors() {
      this.slotSearchError = "";
      this.ConflictError = false;
      this.DuplicateValidationError = false;
      this.currentTimeCheck = false;
    },

    getActiveVenueName() {
      return (
        this.selectedvenuename ||
        sessionStorage.getItem("selectedvenuename") ||
        this.selectedvenueName
      );
    },

    getActiveVenueType() {
      return (
        sessionStorage.getItem("selectedvenuetype") || this.selectedvenueType
      );
    },

    isSettingEnabled(value) {
      return value === true || value === "true" || value === 1 || value === "1";
    },

    parseAdvanceRule(raw) {
      if (raw == null) {
        return { enabled: false, value: 0 };
      }

      if (typeof raw === "number") {
        return { enabled: false, value: raw };
      }

      if (typeof raw === "string" && raw !== "" && !Number.isNaN(Number(raw))) {
        return { enabled: false, value: Number(raw) };
      }

      if (typeof raw !== "object") {
        return { enabled: false, value: 0 };
      }

      const value = Number(
        raw.mindays ??
          raw.minDays ??
          raw.MinDays ??
          raw.minhours ??
          raw.minHours ??
          raw.MinHours ??
          raw.minhour ??
          raw.hours ??
          raw.hour ??
          0
      );
      const enabled = this.isSettingEnabled(
        raw.isallowed ??
          raw.isAllowed ??
          raw.IsAllowed ??
          raw.allowed ??
          raw.enabled ??
          raw.enable
      );

      return { enabled, value };
    },

    applyAdvanceBookingSettings(element) {
      if (!element) {
        this.daysInAdvanceEnable = false;
        this.minDays = 0;
        this.hoursInAdvanceEnable = false;
        this.minHours = 0;
        this.limitMaxDays = 0;
        return;
      }

      const daysAdvance = this.parseAdvanceRule(
        element.bookingdaysinadvance ?? element.bookingDaysInAdvance
      );
      const hoursAdvance = this.parseAdvanceRule(
        element.bookinghoursinadvance ?? element.bookingHoursInAdvance
      );

      this.daysInAdvanceEnable = daysAdvance.enabled;
      this.minDays = daysAdvance.value;
      this.hoursInAdvanceEnable = hoursAdvance.enabled;
      this.minHours = hoursAdvance.value;
      this.limitMaxDays = Number(
        element.limitmaxdaysinadvance ?? element.limitMaxDaysInAdvance ?? 0
      );
    },

    loadAdvanceBookingSettings() {
      const venueTypeSettings = getBookingVenueTypeSettings() || [];
      const venueType = this.getActiveVenueType();
      const element = venueTypeSettings.find(
        (el) => el.venueType === venueType
      );
      this.applyAdvanceBookingSettings(element);
    },

    hasAdvanceBookingRules() {
      return (
        (this.daysInAdvanceEnable && this.minDays > 0) ||
        (this.hoursInAdvanceEnable && this.minHours > 0) ||
        this.limitMaxDays > 0
      );
    },

    checkAdvanceBookingAllowed(startDate) {
      const currentDate = new Date();
      const startDateNormalized = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
      );

      if (this.daysInAdvanceEnable && this.minDays > 0) {
        const daysAdvanceFromNow = new Date(currentDate);
        daysAdvanceFromNow.setDate(currentDate.getDate() + this.minDays);
        daysAdvanceFromNow.setHours(0, 0, 0, 0);

        if (startDateNormalized < daysAdvanceFromNow) {
          this.setSlotSearchError(
            `Start date must be at least ${this.minDays} day${this.minDays > 1 ? "s" : ""} in advance.`
          );
          return false;
        }
      }

      if (this.hoursInAdvanceEnable && this.minHours > 0) {
        const hoursAdvanceFromNow = new Date(currentDate);
        hoursAdvanceFromNow.setTime(
          currentDate.getTime() + this.minHours * 60 * 60 * 1000
        );

        if (startDate < hoursAdvanceFromNow) {
          this.setSlotSearchError(
            `Booking must be at least ${this.minHours} hour${this.minHours > 1 ? "s" : ""} in advance.`
          );
          return false;
        }
      }

      if (this.limitMaxDays > 0) {
        const maxBookingDate = new Date(currentDate);
        maxBookingDate.setDate(currentDate.getDate() + this.limitMaxDays);
        maxBookingDate.setHours(23, 59, 59, 999);

        if (startDateNormalized > maxBookingDate) {
          this.setSlotSearchError(
            `Start date must be within ${this.limitMaxDays} days for booking.`
          );
          return false;
        }
      }

      return true;
    },

    normalizeDateString(dateString) {
      return String(dateString || "").replace(/^["']|["']$/g, "").trim();
    },

    getStartDateForAdvanceCheck() {
      const nonFormatStartDate = this.dateSearch?.nonFormatStartDate;
      if (nonFormatStartDate instanceof Date && !Number.isNaN(nonFormatStartDate.getTime())) {
        return new Date(nonFormatStartDate);
      }

      if (this.dateSearch?.startDate) {
        const parsed = this.parseDate(this.normalizeDateString(this.dateSearch.startDate));
        if (!Number.isNaN(parsed.getTime())) {
          return parsed;
        }
      }

      if (this.selectedDate) {
        const [day, month, year] = this.selectedDate.split("/").map(Number);
        const fallback = new Date(year, month - 1, day, 0, 0, 0);
        if (!Number.isNaN(fallback.getTime())) {
          return fallback;
        }
      }

      return null;
    },

    mergeVenueAndBundle(singleVenues, bundleVenues) {
      // Include all bundle venues and all single venues, regardless of duplication
      return [...bundleVenues, ...singleVenues];
    },

    selectVenue(venueType) {
      this.venueType = [];
      sessionStorage.setItem("venuetype", venueType);
      if (venueType == this.selectedVenueType) {
        this.selectedVenueType = "";
        return;
      }
      this.selectedVenueType = venueType;
      this.selectedBookingList = [];
      for (let i = 0; i < this.bookingList.length; i++) {
        if (this.bookingList[i].venueType == venueType) {
          this.selectedBookingList.push(this.bookingList[i]);
          this.$emit("selectedBookingList", {
            StartTime: this.bookingList[i].StartTime,
            EndTime: this.bookingList[i].EndTime,
            startHours: this.bookingList[i].startHours,
            endHours: this.bookingList[i].endHours,
            maxPeople: this.maxPeople,
            venueId: this.bookingList[i] ? this.bookingList[i].venueID : "",
            bundleVenueIds: this.bookingList[i].bundleVenueIds
              ? this.bookingList[i].bundleVenueIds
              : "",
            venueName: this.bookingList[i].venueName,
            venueType: this.bookingList[i].venueType,
            venueIds: this.bookingList[i].venueIds
              ? this.bookingList[i].venueIds
              : [],
          });
        }
      }
    },
    setSearchDate(dateSearch) {
      this.slotSearchError = "";

      if (dateSearch.invalidBooking == true) {
        this.errorMessageTime = dateSearch.errorMessageTime;
        this.timeErrorType = dateSearch.timeErrorType || null;
        this.bookingInvalid = true;
      } else {
        this.bookingInvalid = false;
        this.timeErrorType = null;
      }

      this.showTimeError = dateSearch.bookingTimeError || dateSearch.errorMessage;
      this.bookingTimeErrorMessage = dateSearch.bookingTimeErrorMessage || "";
      if (this.showTimeError == true) {
        this.bookingInvalid = false;
      }
      if (dateSearch.validTime == false && !dateSearch.bookingTimeError) {
        this.showTimeError = false;
      }
      this.timeRangeInvalid =
        dateSearch.timeRangeValid === false &&
        !dateSearch.invalidBooking &&
        !dateSearch.bookingTimeError;
      this.timeValidity = dateSearch.validTime;
      if (this.timeValidity == true) {
        this.ConflictError = false;
        this.DuplicateValidationError = false;
      }
      this.currentTimeCheck = false;
      this.dateSearch = dateSearch;
      this.venueType = [];
      this.searchResult = false;
      this.bookingList = [];
      this.venuesId = [];
    },
    parseDate(dateString) {
      const normalized = this.normalizeDateString(dateString);
      const [datePart, timePart = "00:00"] = normalized.split(" ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hours, minutes] = timePart.split(":").map(Number);

      return new Date(year, month - 1, day, hours, minutes); // Month is 0-indexed
    },
    async search() {
      this.bookingList = [];
      this.venuesId = [];
      this.loading[3] = true;
      this.selectedVenueType = "";
      let slotSubmitted = false;

      this.clearSlotSearchErrors();
      this.$emit("slot-add-start");

      try {
        if (
          !this.fulldayChecked &&
          (this.bookingInvalid || !this.timeValidity || this.timeRangeInvalid)
        ) {
          const message =
            this.timeErrorType === "no_slots_available" && this.errorMessageTime
              ? this.errorMessageTime
              : "Please select a valid date and time.";
          this.setSlotSearchError(message);
          return;
        }

      // Reset error states
      this.ConflictError = false;
      this.DuplicateValidationError = false;

      // Get venue data from prop (passed from BookingPage, from new API endpoint)
      this.bookingVenuesId = this.venuesFromAPI || [];
      const activeVenueName = this.getActiveVenueName();

      this.loadAdvanceBookingSettings();
      if (this.hasAdvanceBookingRules()) {
        const startDateForAdvance = this.getStartDateForAdvanceCheck();
        if (!startDateForAdvance) {
          this.setSlotSearchError("Please select a valid date and time.");
          this.loading[3] = false;
          return;
        }
        if (!this.checkAdvanceBookingAllowed(startDateForAdvance)) {
          this.loading[3] = false;
          return;
        }
      }

      let singleBookingPageData = getTemporarybookingDetails();

      // Skip date validation for full day bookings
      if (!this.fulldayChecked) {
        for (let index = 0; index < singleBookingPageData.length; index++) {
          const element = singleBookingPageData[index];

          const startDate1 = new Date(this.dateSearch.startDate.slice(1, -1));
          const endDate1 = new Date(this.dateSearch.endDate.slice(1, -1));

          const startDateToMatch = new Date(element.StartTime.slice(1, -1));
          const endDateToMatch = new Date(element.EndTime.slice(1, -1));

          if (startDate1.getTime() === startDateToMatch.getTime()) {
            this.DuplicateValidationError = true;
            this.ConflictError = false;
            this.loading[3] = false;

            return;
          } else if (
            startDate1.getTime() > startDateToMatch.getTime() &&
            startDate1.getTime() < endDateToMatch.getTime()
          ) {
            this.ConflictError = true;
            this.DuplicateValidationError = false;
            this.loading[3] = false;
            return;
          } else if (
            endDate1.getTime() > startDateToMatch.getTime() &&
            endDate1.getTime() < endDateToMatch.getTime()
          ) {
            this.ConflictError = true;
            this.DuplicateValidationError = false;
            this.loading[3] = false;
            return;
          }
        }
      }

      for (let index = 0; index < this.bookingVenuesId.length; index++) {
        const venues = this.bookingVenuesId[index];
        
        // NOTE: API returns lowercase field names (venuename, not venueName)
        const venueName = venues.venuename || venues.venueName;
        const maxPeople = venues.maxpeople || venues.maxPeople;
        const minPeople = venues.minpeople || venues.minPeople;

        if (activeVenueName === venueName) {
          if (this.maxPeople > maxPeople) {
            this.setSlotSearchError("Maximum amount of people allowed exceeded.");
            this.loading[3] = false;
            return;
          }
          if (this.maxPeople < minPeople) {
            this.setSlotSearchError(
              `Minimum ${minPeople} person required for this booking`
            );
            this.loading[3] = false;
            return;
          }

          // Use unique ID from venue data (from new API endpoint)
          // NOTE: API returns lowercase field names (id is already lowercase, but be consistent)
          // CRITICAL: Use the venue ID from sessionStorage (the one used for getcalendar)
          // This ensures we use the exact same ID that worked correctly
          const storedVenueId = sessionStorage.getItem("selectedVenueUniqueId");
          
          if (storedVenueId) {
            // Use the stored venue ID (from getcalendar)
            this.venuesId.push(String(storedVenueId).trim());
          } else {
            // Fallback: use venue ID from data if sessionStorage not available
            const venueId = venues.id;
            if (venueId) {
              this.venuesId.push(String(venueId));
            } else {
              // Fallback for old data structure (shouldn't reach here with new API)
              this.venuesId.push(String(venues.venueID || venues.venueid));
            }
          }
          
          // CRITICAL: Only process one venue match to avoid multiple IDs
          // Break after first match to prevent adding multiple venue IDs
          break;
        }
      }

      if (this.maxPeople == 0) {
        this.setSlotSearchError("Minimum 1 person required for booking");
        this.loading[3] = false;
        return;
      }

      let currentDateTimeStamp = new Date();
      let currentDate = moment(currentDateTimeStamp).format("DD/MM/YYYY");
      let currentHour = currentDateTimeStamp.getHours();
      let currentMinutes = currentDateTimeStamp.getMinutes();
      let minutes = "";
      let hours = "";

      if (currentMinutes <= 9) {
        minutes = "0" + currentMinutes;
      } else {
        minutes = currentMinutes;
      }
      if (currentHour <= 9) {
        hours = "0" + currentHour;
      } else {
        hours = currentHour;
      }

      let currentHourAndMinute = currentDate + " " + hours + ":" + minutes;

      let currentTime = moment(currentHourAndMinute, "DD/MM/YYYY HH:mm").format(
        "X"
      );
      
      // Safety check for dateSearch.endDate (skip for full day bookings)
      if (!this.fulldayChecked && (!this.dateSearch || !this.dateSearch.endDate)) {
        this.loading[3] = false;
        this.setSlotSearchError("Date search data is missing. Please try again.");
        return;
      }
      
      // For full day bookings, use venue's start/end from dateSearch (set by DateSearchComponent from API working hours), else fallback
      let startDate, endDate;
      if (this.fulldayChecked) {
        if (this.dateSearch && this.dateSearch.startDate && this.dateSearch.endDate) {
          startDate = this.dateSearch.startDate;
          endDate = this.dateSearch.endDate;
        } else {
          let formattedDate;
          if (this.selectedDate) {
            formattedDate = this.selectedDate;
          } else {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const year = today.getFullYear();
            formattedDate = `${day}/${month}/${year}`;
          }
          startDate = `${formattedDate} 07:00`;
          endDate = `${formattedDate} 21:00`;
        }
      } else {
        startDate = this.dateSearch.startDate;
        endDate = this.dateSearch.endDate;
      }
      
      let selectedTime = moment(
        endDate,
        "DD/MM/YYYY HH:mm"
      ).format("X");

      if (currentTime >= selectedTime) {
        this.loading[3] = false;
        this.currentTimeCheck = true;
        this.bookingInvalid = false;
        return;
      }

      // CRITICAL: Ensure venuesId contains only one venue ID (the one from sessionStorage/getcalendar)
      // Use the stored venue ID from sessionStorage if available
      let finalVenuesId = [];
      const storedVenueId = sessionStorage.getItem("selectedVenueUniqueId");
      
      if (storedVenueId) {
        // Use the stored venue ID (from getcalendar) - ensure it's a single string
        let singleId = String(storedVenueId).trim();
        if (singleId.includes(',')) {
          singleId = singleId.split(',')[0].trim();
        }
        finalVenuesId = [singleId];
      } else if (this.venuesId && this.venuesId.length > 0) {
        // Fallback: use first ID from venuesId array
        let singleId = String(this.venuesId[0]).trim();
        if (singleId.includes(',')) {
          singleId = singleId.split(',')[0].trim();
        }
        finalVenuesId = [singleId];
      }

      const results = await search({
        StartDate: startDate,
        EndDate: endDate,
        UniqueVenueIds: finalVenuesId,
      });
      
      this.showResults = true;
      this.bookingList = [];

      // First, check if any result has isBooked === true
      // If so, immediately return without proceeding
      for (let i = 0; i < results?.length; i++) {
        const result = results[i];
        
        if (result.isBooked === true || result.isBooked === "true") {
          const venue = this.bookingVenuesId.find((v) => {
            if ((v.venueid || v.venueID) === result.VenueId) return true;
            if (v.id === result.UniqueVenueId) return true;
            const bundleIds = v.bundlevenueids || v.bundleVenueIds;
            if (bundleIds && Array.isArray(bundleIds)) {
              return bundleIds.includes(result.VenueId);
            }
            return false;
          });

          const isBundleVenue = venue && venue.bundlevenueids && Array.isArray(venue.bundlevenueids) && venue.bundlevenueids.length > 0;
          this.setSlotSearchError(
            isBundleVenue
              ? "One or more venues in this bundle are already booked at the selected date and time. Please choose a different time slot."
              : "This venue is already booked at the selected date and time. Please choose a different time slot."
          );
          this.loading[3] = false;
          return;
        }
      }
      
      // NOTE: API returns lowercase field names (venuename, not venueName)
      let venue = this.bookingVenuesId.find(
        (v) => (v.venuename || v.venueName) === activeVenueName
      );
      
      if (venue && this.maxPeople <= (venue.maxpeople || venue.maxPeople)) {
        // Use lowercase field names from API with fallback to camelCase
        this.bookingList.push({
          venueName: venue.venuename || venue.venueName,
          venueID: venue.venueid || venue.venueID || "",
          uniqueVenueId: venue.id || "",  // Add unique venue ID (e.g., "FCC-VEN-1")
          bundleVenueIds: venue.bundlevenueids || venue.bundleVenueIds || "",
          maxPeople: venue.maxpeople || venue.maxPeople,
          IsBusiness: false,
          StartTime: this.dateSearch.startDate,
          EndTime: this.dateSearch.endDate,
          startHours: this.dateSearch.startHours,
          endHours: this.dateSearch.endHours,
          venuePhoto: venue.venuephoto || venue.venuePhoto,
          venueType: venue.venuetype || venue.venueType,
          venueIds: venue.venueids || venue.venueIds || [],
          venueData: {  // Store complete venue data for reference
            id: venue.id,
            venueID: venue.venueid || venue.venueID,
            bundleVenueIds: venue.bundlevenueids || venue.bundleVenueIds,
          }
        });
        const venueTypeValue = venue.venuetype || venue.venueType;
        if (!this.venueType.includes(venueTypeValue)) {
          this.venueType.push(venueTypeValue);
        }
        this.selectVenue(venueTypeValue);
        slotSubmitted = true;
      }

      if (this.bookingList.length == 0) {
        this.setSlotSearchError(
          "This venue is not available at this date and time."
        );
        return;
      }
      } catch (error) {
        console.error("Search booking failed:", error);
        this.setSlotSearchError("Something went wrong. Please try again.");
      } finally {
        this.loading[3] = false;
        if (!slotSubmitted) {
          this.$emit("slot-add-end");
        }
      }
    },
    onDateSelected(formattedDate) {
      this.$emit('dateSelected', formattedDate);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style src="./searchbydate.css"></style>
